import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_payment_tile = _resolveComponent("payment-tile")

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.availablePaymentMethodItems, (paymentMethod) => {
      return (_openBlock(), _createBlock(_component_payment_tile, _mergeProps({
        key: paymentMethod.type
      }, { ref_for: true }, paymentMethod, {
        onSelected: $options.onPaymentSelected,
        "data-qa": paymentMethod.dataQa
      }), {
        default: _withCtx(() => [
          (paymentMethod.component)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(paymentMethod.component), {
                key: 0,
                ref_for: true,
                ref: "paymentMethodForm",
                "is-save-card-checkbox-visible": true,
                "enabled-card-networks": $options.enabledCardNetworks,
                onFormDetailsChanged: $options.onPaymentMethodFormChange
              }, null, 40 /* PROPS, NEED_HYDRATION */, ["enabled-card-networks", "onFormDetailsChanged"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 2 /* DYNAMIC */
      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onSelected", "data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}